import * as React from "react";
import { flexRender } from "@tanstack/react-table";
import styled, { css } from "styled-components";
import { Table as BaseTable } from "components/bootstrap";
import ExpandedSections from "components/common/EntityDataTable/ExpandedSections";
import { CELL_PADDING } from "components/common/EntityDataTable/Constants";
import {
  columnOpacityVar,
  columnTransformVar,
  columnTransition,
  displayScrollRightIndicatorVar
} from "components/common/EntityDataTable/CSSVariables";
import ScrollShadow from "theme/box-shadows/ScrollShadow";
import TableHead from "./TableHead";
const StyledTable = styled(BaseTable)(
  ({ theme }) => css`
    table-layout: fixed;
    margin-bottom: 0;
    height: 100%; // required to be able to use height: 100% in td

    thead > tr > th,
    tbody > tr > td {
      padding: ${CELL_PADDING}px;
    }

    && {
      > tbody:nth-of-type(even) > tr {
        background-color: ${theme.colors.table.row.backgroundStriped};
      }

      > tbody:nth-of-type(odd) > tr {
        background-color: ${theme.colors.table.row.background};
      }
    }
  `
);
const Td = styled.td(
  ({ $colId, $hidePadding, $pinningPosition }) => css`
    word-break: break-word;
    opacity: var(${columnOpacityVar($colId)}, 1);
    transform: var(${columnTransformVar($colId)}, none);
    transition: var(${columnTransition()}, none);
    height: 100%; // required to be able to use height: 100% in child elements
    ${$pinningPosition ? css`
          position: sticky;
          ${$pinningPosition === "left" ? "left" : "right"}: 0;
          ${ScrollShadow("left")}
          &::before {
            display: var(${displayScrollRightIndicatorVar}, none);
          }
        ` : ""}

    ${$hidePadding && css`
      && {
        padding: 0;
      }
    `}
  `
);
const Table = ({ expandedSectionRenderers, headerGroups, rows }) => /* @__PURE__ */ React.createElement(StyledTable, { striped: true, condensed: true, hover: true }, /* @__PURE__ */ React.createElement(TableHead, { headerGroups }), rows.map((row) => /* @__PURE__ */ React.createElement("tbody", { key: `table-row-${row.id}`, "data-testid": `table-row-${row.id}` }, /* @__PURE__ */ React.createElement("tr", null, row.getVisibleCells().map((cell) => {
  const columnMeta = cell.column.columnDef.meta;
  return /* @__PURE__ */ React.createElement(
    Td,
    {
      key: cell.id,
      $colId: cell.column.id,
      $pinningPosition: cell.column.getIsPinned(),
      $hidePadding: columnMeta == null ? void 0 : columnMeta.hideCellPadding
    },
    flexRender(cell.column.columnDef.cell, cell.getContext())
  );
})), /* @__PURE__ */ React.createElement(
  ExpandedSections,
  {
    key: `expanded-sections-${row.id}`,
    expandedSectionRenderers,
    entity: row.original
  }
))));
export default React.memo(Table);
